var map = {
	".": 1035,
	"./": 1035,
	"./component/mc-breadcrumbs.component": 6773,
	"./component/mc-breadcrumbs.component.ts": 6773,
	"./index": 1035,
	"./index.ts": 1035,
	"./mc-breadcrumbs.module": 5426,
	"./mc-breadcrumbs.module.ts": 5426,
	"./mc-breadcrumbs.shared": 4184,
	"./mc-breadcrumbs.shared.ts": 4184,
	"./service/mc-breadcrumbs.config": 5026,
	"./service/mc-breadcrumbs.config.ts": 5026,
	"./service/mc-breadcrumbs.resolver": 2226,
	"./service/mc-breadcrumbs.resolver.ts": 2226,
	"./service/mc-breadcrumbs.service": 6118,
	"./service/mc-breadcrumbs.service.ts": 6118,
	"app/breadcrumbs": 1035,
	"app/breadcrumbs/": 1035,
	"app/breadcrumbs/component/mc-breadcrumbs.component": 6773,
	"app/breadcrumbs/component/mc-breadcrumbs.component.ts": 6773,
	"app/breadcrumbs/index": 1035,
	"app/breadcrumbs/index.ts": 1035,
	"app/breadcrumbs/mc-breadcrumbs.module": 5426,
	"app/breadcrumbs/mc-breadcrumbs.module.ts": 5426,
	"app/breadcrumbs/mc-breadcrumbs.shared": 4184,
	"app/breadcrumbs/mc-breadcrumbs.shared.ts": 4184,
	"app/breadcrumbs/service/mc-breadcrumbs.config": 5026,
	"app/breadcrumbs/service/mc-breadcrumbs.config.ts": 5026,
	"app/breadcrumbs/service/mc-breadcrumbs.resolver": 2226,
	"app/breadcrumbs/service/mc-breadcrumbs.resolver.ts": 2226,
	"app/breadcrumbs/service/mc-breadcrumbs.service": 6118,
	"app/breadcrumbs/service/mc-breadcrumbs.service.ts": 6118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9910;